/* eslint-disable @typescript-eslint/no-explicit-any */
import { colorDefault } from "./ColorDefault";

const configurationUtils = {
  getIcon: function (state: string) {
    switch (state) {
      case "online":
        return {
          bgColor: colorDefault.Sensolus_Blue_Darkest,
          bgHoverColor: colorDefault.Sensolus_BG_LightBlue,
          bgSelectedColor: colorDefault.Sensolus_Orange,
          iconColor: colorDefault.White,
          iconHoverColor: colorDefault.Sensolus_Blue_Darkest,
        };
      case "offline":
        return {
          bgColor: colorDefault.Sensolus_Grey_Light,
          bgHoverColor: colorDefault.Sensolus_BG_LightBlue,
          bgSelectedColor: colorDefault.Sensolus_Orange,
          iconColor: colorDefault.White,
          iconHoverColor: colorDefault.Sensolus_Blue_Darkest,
        };
      case "cluster":
        return {
          bgColor: colorDefault.Sensolus_BG_Blue,
          bgHoverColor: colorDefault.Sensolus_BG_LightBlue,
          bgSelectedColor: colorDefault.Sensolus_Orange,
          iconColor: colorDefault.White,
          iconHoverColor: colorDefault.Sensolus_Blue_Darkest,
        };
      case "cluster_infras":
        return {
          bgColor: colorDefault.Sensolus_Pink_Dark,
          bgHoverColor: colorDefault.Sensolus_BG_LightBlue,
          bgSelectedColor: colorDefault.Sensolus_Orange,
          iconColor: colorDefault.White,
          iconHoverColor: colorDefault.Sensolus_Pink_Dark,
        };
      case "cluster_geozone":
        return {
          bgColor: colorDefault.Sensolus_Geozone_Green,
          bgHoverColor: colorDefault.Sensolus_BG_LightBlue,
          bgSelectedColor: colorDefault.Sensolus_Orange,
          iconColor: colorDefault.White,
          iconHoverColor: colorDefault.Sensolus_Geozone_Green,
        };
      case "geozone":
        return {
          bgColor: colorDefault.Sensolus_Geozone_Green,
          bgHoverColor: colorDefault.Sensolus_BG_LightBlue,
          bgSelectedColor: colorDefault.Sensolus_Orange,
          iconColor: colorDefault.White,
          iconHoverColor: colorDefault.Sensolus_Geozone_Green,
        };
      case "sitemap":
        return {
          bgColor: colorDefault.White,
          bgHoverColor: colorDefault.Sensolus_BG_LightBlue,
          bgSelectedColor: colorDefault.Sensolus_Orange,
          iconColor: colorDefault.Sensolus_Blue_Darkest,
          iconHoverColor: colorDefault.White,
        };
      case "cluster_sitemap":
        return {
          bgColor: colorDefault.White,
          bgHoverColor: colorDefault.Sensolus_BG_LightBlue,
          bgSelectedColor: colorDefault.Sensolus_Orange,
          iconColor: colorDefault.Sensolus_Blue_Darkest,
          iconHoverColor: colorDefault.White,
        };
      case "location":
        return {
          iconColor: colorDefault.Sensolus_Blue_Darkest,
          iconHoverColor: colorDefault.Sensolus_Orange,
        };
      case "location-satellite":
        return {
          iconColor: colorDefault.Sensolus_BG_LightBlue,
          iconHoverColor: colorDefault.Sensolus_Orange,
        };
      default:
        break;
    }
  },
  getJourneyIcon: function (state: string) {
    switch (state) {
      case "marker":
        return {
          bgColor: colorDefault.Sensolus_Blue_Darkest,
          bgHoverColor: colorDefault.Sensolus_Map_HighLight,
          bgSelectedColor: colorDefault.Sensolus_Orange,
        };
      case "marker-satellite":
        return {
          bgColor: colorDefault.Sensolus_Marker_Blue,
          bgHoverColor: colorDefault.Sensolus_Grey,
          bgSelectedColor: colorDefault.Sensolus_Orange,
        };
      case "marker-pink":
        return {
          bgColor: colorDefault.Sensolus_Pink_Light,
          bgHoverColor: colorDefault.Sensolus_Map_HighLight,
          bgSelectedColor: colorDefault.Sensolus_Orange,
        };
      case "marker-green":
        return {
          bgColor: colorDefault.Sensolus_Green_Light,
          bgHoverColor: colorDefault.Sensolus_Map_HighLight,
          bgSelectedColor: colorDefault.Sensolus_Orange,
        };
      case "marker-blue":
        return {
          bgColor: colorDefault.Sensolus_Blue,
          bgHoverColor: colorDefault.Sensolus_Map_HighLight,
          bgSelectedColor: colorDefault.Sensolus_Orange,
        };
      case "marker-brown":
        return {
          bgColor: colorDefault.Sensolus_Brown_Light,
          bgHoverColor: colorDefault.Sensolus_Map_HighLight,
          bgSelectedColor: colorDefault.Sensolus_Orange,
        };
      case "marker-purple":
        return {
          bgColor: colorDefault.Sensolus_Purple_Light,
          bgHoverColor: colorDefault.Sensolus_Map_HighLight,
          bgSelectedColor: colorDefault.Sensolus_Orange,
        };
      default:
        break;
    }
  },
  getState: function (device: any) {
    return device.trackerStatus === "OFFLINE" ? "offline" : "online";
  },
  getActivityState: function (device: any) {
    let activityState;
    const lastActivity = device.lastActivityState;
    if (lastActivity && lastActivity === "STOP") {
      activityState = "stop";
    } else if (
      lastActivity &&
      (lastActivity === "START" ||
        lastActivity === "EXIT" ||
        lastActivity === "ON_THE_MOVE")
    ) {
      activityState = "moving";
    } else {
      activityState = "periodic";
    }
    return activityState;
  },
  getHighestAlertSeverity: function (device: any) {
    const highestSeverity = null;
    if (device.highestSeverity) {
      return device.highestSeverity;
    } else if (device.activeServices?.length) {
      const alertService = device.activeServices.find(
        (s: any) => s.serviceKey.name === "ALERT"
      );
      return alertService?.highestSeverity;
    }
    return highestSeverity;
  },
  getAlertColor: function (alertSeverity: string | number) {
    let alertbgColor = "#0071a1";
    switch (alertSeverity) {
      case "REMINDER":
        alertbgColor = "#0071a1";
        break;
      case "WARNING":
        alertbgColor = "#ffcc66";
        break;
      case "CRITICAL":
        alertbgColor = "#e00000";
        break;
    }
    return alertbgColor;
  },
};
export default configurationUtils;
